import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCalendar, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import useApi from '../../hooks/api';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { requestsSet } from '../../store/requestsSlice';
import { slotsSet } from '../../store/slotsSlice';
import { Request, Slot } from '../../types';
import RequestList from './RequestList';
import SlotList from './SlotList';
import './Schedule.css';
import { get } from '../../utils/api';

type Slots = {
	slots: Slot[]
};

type ErrorText = {
    ru: string;
    en: string;
};

type Requests = {
    requests: Request[]
}

const MONTH_RU = ['Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря'];
const MONTH_EN = ['January','February','March','April','May','June','July','August','September','October','November','December'];

const Schedule: FC = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
    const user = useAppSelector(store => store.auth.user);
    const dispatch = useAppDispatch();
    const [ slots, errorSlots, isLoadingSlots ] = useApi('get', '/slots');
    const [ errorRequests, setErrorRequests ] = useState<ErrorText|null>(null);
    const [ isSlotsView, setIsSlotsView ] = useState(true);
    const [ needAttention, setNeedAttention ] = useState(false);

    // Запускаем периодический опрос запросов
    useEffect(() => {
        const fetchRequests = async () => {
            const result = await get('/requests');
            if(result.error) setErrorRequests(result.error.text);
            if(result.data) {
                const requests = (result.data as Requests).requests;
                dispatch(requestsSet(requests));
                // Узнаем есть ли запросы требующие нашего внимания для индикатора
                const req = requests.find(r => r.status === 'negotiation' && r.actor_id !== user?.id);
                if(req) setNeedAttention(true); else setNeedAttention(false);
            }
        };
        // Запустим интервал
        const timerId = setInterval(() => fetchRequests(), 10 * 1000);
        // И сразу сделаем первый запрос
        fetchRequests();
        // Очистим интервал при размонтировании
        return () => clearInterval(timerId);
    }, [ dispatch, user ]);

    useEffect(() => {
        if(!slots) return;
        let slotsWithDates = [...(slots as Slots).slots];
        for(let i = 0; i < slotsWithDates.length; i ++) {
            const date = new Date(slotsWithDates[i].start);
            slotsWithDates[i].date_ru = date.getDate() + ' ' + MONTH_RU[date.getMonth()];
            slotsWithDates[i].date_en = date.getDate() + ' ' + MONTH_EN[date.getMonth()];
        }
        dispatch(slotsSet(slotsWithDates));
    }, [ slots, dispatch ]);

    if(isLoadingSlots) return <div>{t('common.loading')}</div>;
    if(errorSlots) return <div className='error'>{errorSlots.text[lang]}</div>;
    if(errorRequests) return <div className='error'>{errorRequests[lang]}</div>;
    if(!slots) return <div>{t('common.noslots')}</div>

	return (
        <div className='Schedule'>
            <div className='SwitchView'>
                <div className={isSlotsView ? 'Selected' : undefined} onClick={() => setIsSlotsView(!isSlotsView)}>
                    <Icon icon={faCalendar}/>&nbsp;&nbsp;{t('profile.schedule')}
                </div>
                <div className={isSlotsView ? undefined : 'Selected'} onClick={() => setIsSlotsView(!isSlotsView)}>
                    {needAttention ? 
                        <span className="fa-layers fa-fw">
                            <Icon icon={faEnvelope}/>
                            <span className="fa-layers-counter" style={{background:'tomato'}}>&nbsp;</span>
                        </span>
                        : <Icon icon={faEnvelope}/>}
                    &nbsp;&nbsp;{t('profile.requests')}
                </div>
            </div>

            {isSlotsView ? <SlotList/> : <RequestList/>}
        </div>
	);
};

export default Schedule;
